import React from 'react';
import { observer } from 'mobx-react-lite';
import GameLeftSide from '../gameLeftSide';
import GameRightSide from '../gameRightSide';
import GameCenterSide from '../gameCenterSide';

export const GameWrapper = observer(() => {
  return (
    <div className='new-fishing-wrapper'>
      <GameLeftSide />
      <GameCenterSide />
      <GameRightSide />
    </div>
  );
});
